import { create } from "zustand";
const usePassStore = create((set)=>({
        redirectPath: null,
        setRedirectPath: (url)=>set({
                redirectPath: url
            })
    }));
export default usePassStore;
